import {
  ADD_SETTING_FAIL,
  ADD_SETTING_REQUEST,
  ADD_SETTING_SUCCESS,
  DELETE_SETTING_FAIL,
  DELETE_SETTING_REQUEST,
  DELETE_SETTING_SUCCESS,
  EDIT_SETTING_FAIL,
  EDIT_SETTING_REQUEST,
  EDIT_SETTING_SUCCESS,
  GET_MODULE_FAIL,
  GET_MODULE_REQUEST,
  GET_MODULE_SUCCESS,
  GET_SETTING_FAIL,
  GET_SETTING_LIST_DATA_FAIL,
  GET_SETTING_LIST_DATA_REQUEST,
  GET_SETTING_LIST_DATA_SUCCESS,
  GET_SETTING_REQUEST,
  GET_SETTING_SUCCESS,
} from "../constant";


const initialState = {
  settingData: []
};

const settingReducer = (state = initialState, action) => {

  switch (action.type) {
    //Get survey
    case GET_SETTING_REQUEST:
      return {
        ...state,
        settingData: []
      };
    case GET_SETTING_SUCCESS:
      return {
        ...state,
        settingData: action.payload?.data,
      };

    case GET_SETTING_LIST_DATA_REQUEST:
      return {
        ...state,
      };
    case GET_SETTING_LIST_DATA_SUCCESS:
      const listData = action.payload;
      let tmpList = state?.settingData?.map((setting) => ({
        ...setting
      }));
      return {
        ...state,
        settingData: [...tmpList],
      };
    //Add SETTING
    case ADD_SETTING_REQUEST:
      return {
        ...state,
      }

    case ADD_SETTING_SUCCESS:
      const { id, data } = action.payload

      const field = {
        type: data.type,
        value: data.value,
      }
      return {
        ...state,
        settingData: [...state.settingData, field]
      }
    case ADD_SETTING_FAIL:
      return {
        ...state,
      }

    default:
      return state;
  }
};

export { settingReducer };
